import type { Values } from '@lt/widget/components/Cigarette/context';

import { EMPTY_DATE, getDateForDisplay } from 'src/utils/cigaretteUtils';
import type { SearchType } from 'src/types/search';

export const getDurationTripProps = (
  datepicker: Values['datepicker'],
  searchType: SearchType,
) => {
  const left = datepicker?.left
    ? { ...datepicker.left, date: getDateForDisplay(datepicker.left.date) }
    : EMPTY_DATE;
  const right = datepicker?.right
    ? { ...datepicker.right, date: getDateForDisplay(datepicker.right.date) }
    : EMPTY_DATE;

  return {
    leftValue: left,
    rightValue: right,
    shift: datepicker?.shift ?? 0,
    openCalendar: () => null,
    searchType,
    isStartDateFocus: false,
    isEndDateFocus: false,
  };
};
